import { Modal, Button } from 'antd';
import React, { Component } from 'react';
import { Form, Select, Input } from 'antd';

//from material ui
import Box from '@material-ui/core/Box'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import PropTypes from 'prop-types';

import modalActions from '../../../redux/organization/actions';
 
import ShowListUser from '../ShowListUser';
const { Option } = Select;

const initialState = {
};

class ModalOrgani extends React.Component {
   constructor(props) {
      super(props)
      this.state = initialState;
   }
   componentWillReceiveProps(nextProps) {

   }
   componentDidMount() {
   }
   _handleOk = e => {
      console.log("_handleOk");
   };

   _handleCancel = e => {
      const { modalActionCreators } = this.props
      const { hideModalUsers } = modalActionCreators
      hideModalUsers()
   };
   
   render() {
      //console.log("render showModalUsers: ", showModalUsers)
      const { showModalUsers, titleModalListUser, titleButtonModal, listUser } = this.props
      return (
         <div >
            <Modal
               title={titleModalListUser}
               visible={showModalUsers}
               onOk={() => { console.log() }}
               onCancel={() => this._handleCancel()}
               centered
               footer={null}
               maskClosable ={false}
               width = {600}
            >
               <ShowListUser   />
            </Modal>
            
         </div>
      );
   }
}

const WrappedApp = Form.create({ name: 'organizationModalUsers' })(ModalOrgani);

WrappedApp.propTypes = {
   showModalUsers: PropTypes.bool,
};

const mapStateToProps = state => {
   
   return {
      listUser:state.organization.listUser,
      showModalUsers: state.organization.showModalUsers,
      titleModalListUser:state.organization.titleModalListUser
   };
};

const mapDispatchToProps = dispatch => {
   return {
      modalActionCreators: bindActionCreators(modalActions.action, dispatch),
   };
};

export default connect(
   mapStateToProps,
   mapDispatchToProps
)(WrappedApp)
